// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DocumentStatus } from '@interfaces/document.interfaces';
import { EnumDisplayNamesToArray } from 'src/app/utils/enum-utils';
import { LightweightPdfViewModalComponent } from '../lightweight-pdf-view-modal/lightweight-pdf-view-modal.component';

@Component({
    selector: 'app-internal-document-intervention-modal',
    templateUrl: './internal-document-intervention-modal.component.html',
    styleUrls: ['./internal-document-intervention-modal.component.scss'],
})
export class InternalDocumentInterventionModalComponent implements OnInit, OnDestroy {
    protected isComponentAlive = true;
    public isLoading = false;
    public documentName: string = null;
    public selectedCurrentStatus: number = null;
    public documentStatuses: string[] = [];
    public signatureImagesOnDocChecked = false;
    public overrideIsCertifiedChecked = false;

    constructor(
        private dialogRef: MatDialogRef<InternalDocumentInterventionModalComponent>,
        private readonly dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            docDisplayName: string;
            documentStatus: number;
            docId: number;
            dealId: number;
            deviceModalWidth: any;
            deviceModalHeight: any;
        }
    ) {
        dialogRef.disableClose = true;
    }

    ngOnInit(): void {
        this.documentName = this.data.docDisplayName;
        this.selectedCurrentStatus = this.data.documentStatus;
        this.documentStatuses = EnumDisplayNamesToArray(DocumentStatus);
        let docIndex = -1;
        docIndex = this.documentStatuses.findIndex((x) => x === DocumentStatus[this.data.documentStatus]);
        if (docIndex !== -1) {
            this.documentStatuses.splice(docIndex, 1);
        }
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }

    public async helpDocumentsFormSubmit(): Promise<void> {
        this.dialogRef.close({
            type: 'reQueue',
            signatureImagesOnDoc: this.signatureImagesOnDocChecked,
            overrideIsCertified: this.overrideIsCertifiedChecked,
        });
    }

    public async helpDocumentsSumbitStatus(documentStatusChange: number): Promise<void> {
        const requestStatus = documentStatusChange.toString();
        if (requestStatus === this.data.documentStatus.toString()) {
            console.error('Can not change status to the current status.');
            return;
        }

        const selectedDocumentStatus: DocumentStatus = DocumentStatus[requestStatus];
        this.dialogRef.close({
            selectedDocumentStatus: selectedDocumentStatus,
            type: 'status',
        });
    }

    toggleSwitchPdfImageCheck($event) {
        this.signatureImagesOnDocChecked = $event.checked;
    }

    toggleSwitchOverrideCertCheck($event) {
        this.overrideIsCertifiedChecked = $event.checked;
    }

    public showPdfViewModal(): void {
        this.isLoading = false;
        this.dialog.open(LightweightPdfViewModalComponent, {
            width: this.data.deviceModalWidth + 'px',
            height: this.data.deviceModalWidth + 'px',
            closeOnNavigation: false,
            data: {
                dealId: this.data.dealId,
                documentId: this.data.docId,
                // only Open and Closed can be printed
                printButtonVisible: false,
                downloadButtonVisible: false,
            },
        });
    }

    cancel(): void {
        this.close();
    }

    close(): void {
        this.dialogRef.close();
    }
}
